<template>
    <div class="be-splash-screen">
        <div :class="`be-wrapper ${wrapperClass}`">
            <div class="be-content">
                <div class="main-content container-fluid">
                    <div class="splash-container">
                        <slot/>
                        <div class="splash-footer" v-if="!!$slots.footer"><slot name="footer"/></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            wrapperClass: String,
        },
    };
</script>
